import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
const TextArea = (props) => {
  const { label, name, hasError, handleBlur, ...rest } = props;
  const [focused, setFocused] = useState(false);
  return (
    <>
      <div
        className={
          hasError
            ? `form-group has-error star ${focused ? "item-focused" : ""}`
            : `form-group star ${focused ? "item-focused" : ""}`
        }
      >
        <label htmlFor={name}> {label}</label>
        <div className="input">
          <Field
            onFocus={() => setFocused(true)}
            onBlur={(e) => {
              setFocused(false);
              handleBlur && handleBlur(e);
            }}
            as="textarea"
            className="form-control"
            id={name}
            name={name}
            {...rest}
          />
        </div>
      </div>
      <ErrorMessage name={name} component={TextError} />
    </>
  );
};

export default TextArea;
